exports.components = {
  "component---src-layouts-root-layout-tsx": () => import("./../../../src/layouts/RootLayout.tsx" /* webpackChunkName: "component---src-layouts-root-layout-tsx" */),
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-search-js": () => import("./../../../src/pages/search.js" /* webpackChunkName: "component---src-pages-search-js" */)
}

